import { hlyRouter } from 'utils/routerTools';
import ApplicationHandler from 'service/application';
import { customDepartmentName } from 'service/job';

/**
 * 首页 老版提单和新版本提单复用api
 * 后面这个文件可以放到 refactor-main
 */
const formCodeMap = {
  //102: ['2001', '2002', '2004'], //申请单
  102: ['3001', '3002', '3003'], //报销单
  104: ['2005', '2006'], //借款单
  106: ['3004'], //对公支付单
  //publicApplication: ['2007'], //对公申请单
  110: ['2101'], //合同
  //budgetJournal: ['8010'], //预算日记账
  111: ['9003'], //我的供应商
  //salary: ['1501'], //工资发放单
  //accrual: ['1701'], //预提单
};

const formTypeAppCodeMap = {
  /*
  差旅申请单 2001
  费用申请单 2002
  订票申请单 2003
  京东订单申请 2004

  单行借款单 2005
  多行借款单 2006

  合同 2101

  日常报销单 3001
  差旅报销单 3002
  费用报销单 3003

  对公支付单 3004
   */
  APPLICATION_FORM: ['2001', '2002', '2004'], //申请单
  EXPENSE_CLAIM: ['3001', '3002', '3003'], //报销单
  LOAN_BILL: ['2005', '2006'], //借款单
  BUSSINESS_PAYMENT: ['3004'], //对公支付单

  //publicApplication: ['2007'], //对公申请单

  // issue-151682 【交付-阿维塔】企微应用快速提单，提对公申请单时，关联合同没有数据
  AP_REQUEST: ['2007'], //对公申请单
  CONTRACTS: ['2101'], //合同

  //budgetJournal: ['8010'], //预算日记账

  MY_SUPPLIER: ['9003'], //我的供应商

  //salary: ['1501'], //工资发放单
  //accrual: ['1701'], //预提单
};

export default {
  joinJobText(data) {
    data = data || [];
    data.forEach((company) => {
      let { userJobsDTOList, companyName } = company;
      company.name = companyName;
      userJobsDTOList.forEach((item) => {
        let { position, rank, duty, tenantDefault } = item,
          tempArr = [];
        if (duty) {
          tempArr.push(window.$t('global-1.key171', { arg1: duty, cm: '职务: {arg1}' }));
        }
        if (rank) {
          tempArr.push(window.$t('global-1.key172', { arg1: rank, cm: '级别: {arg1}' }));
        }
        item.mainText = `${position}`;
        if (tenantDefault) {
          item.mainText = item.mainText + window.$t('global-1.key173', { cm: '（主岗）' });
        }
        item.extraText = customDepartmentName(item.departmentName, item.departmentPath) || '';
        // 职位 公司名称 部门名称 职务名称 级别名称
        // position companyName departmentName duty rank
        item.combineText = [item.companyName, item.duty, item.extraText, item.mainText, item.rank, companyName].join(
          ' '
        );
      });
      company.list = userJobsDTOList;
    });
    return data;
  },
  getAppCodeByFormType(formType) {
    let appCode = '';
    for (let key in formTypeAppCodeMap) {
      let formList = formTypeAppCodeMap[key];
      if (formList.indexOf(formType + '') > -1) {
        appCode = key;
      }
    }
    return appCode;
  },
  //快捷提单创建单据
  createDocument({
    formTypeSrc,
    applicant,
    document,
    job,
    jobId,
    nowJobId,
    isExpense,
    copy = false,
    copyDetail = {},
    setNewApplyParam,
  }) {
    let formType = formTypeSrc;

    if (!formTypeSrc) {
      for (let key in formCodeMap) {
        let formList = formCodeMap[key];
        if (formList.indexOf(document.formType + '') > -1) {
          formType = Number(key);
        }
      }
    }

    if (formType === 102) {
      if (isExpense) {
        hlyRouter.push({
          name: 'er-create-new',
          query: {
            formType: document.formType,
            applicantOID: applicant.userOID,
            jobId: nowJobId || jobId,
            applicantName: applicant.fullName,
          },
          params: {
            docType: 'expenseReport',
            formOID: document.formOID,
            invoiceOIDs: this.invoiceOIDs,
            recommendExpenseOID: document.expenseReportOID,
          },
        });
        return !1;
      }
      // 报销单
      hlyRouter.push({
        name: 'er-create-new',
        params: {
          formOID: document.formOID,
          docType: 'expenseReport',
          job: job,
        },
        query: {
          formType: document.formType,
          applicantOID: applicant.userOID,
          applicantName: applicant.fullName,
          jobId,
          operate: copy && 'copy',
          sourceExpenseReportOID: copy && copyDetail.expenseReportOID, //此处不能为expenseReportOID，否则就是编辑单据了
        },
      });
    } else if (formType === 104) {
      // 借款单
      hlyRouter.push({
        name: 'loan-bill-create',
        params: {
          formOID: document.formOID,
          docType: 'loanBill',
          job: job,
        },
        query: {
          formType: document.formType,
          applicantOID: applicant.userOID,
          applicantName: applicant.fullName,
          jobId,
        },
      });
    } else if (formType === 105) {
      // 付款申请单
      hlyRouter.push({
        name: 'payment-request-create',
        params: {
          formOID: document.formOID,
          docType: 'paymentRequest',
          job: job,
        },
        query: {
          formType: document.formType,
          applicantOID: applicant.userOID,
          applicantName: applicant.fullName,
          jobId,
        },
      });
    } else if (formType === 106) {
      hlyRouter.push({
        name: 'create-corp-payment',
        params: {
          formOID: document.formOID,
          docType: 'corpPayment',
          job: job,
        },
        query: {
          formType: document.formType,
          applicantOID: applicant.userOID,
          applicantName: applicant.fullName,
          jobId,
        },
      });
    } else if (formType === 111) {
      hlyRouter.push({
        name: 'my-supplier-basic-info',
        params: {
          formOID: document.formOID,
          id: ':id',
        },
        query: {
          formType: document.formType,
          applicantOID: applicant.userOID,
          applicantName: applicant.fullName,
          jobId,
        },
      });
    } else if (formType === 110) {
      hlyRouter.push({
        name: 'create-contract',
        params: {
          formOID: document.formOID,
          docType: 'contract',
          job: job,
        },
        query: {
          formType: document.formType,
          applicantOID: applicant.userOID,
          applicantName: applicant.fullName,
          jobId,
        },
      });
    } else {
      // 申请单
      setNewApplyParam('');
      if (document.formType == '4100') {
        // this.hlyRouter.push({
        //     name: "flybackProject"
        // });

        hlyRouter.push({
          name: 'handProject',
          query: {
            action: 'create',
            formOID: document.formOID,
            access_token: this.getUserToken.access_token,
            platform: 'isWechat',
          },
        });
      } else {
        if (ApplicationHandler.isAcceptancePOC(document.formType, document.formOID)) {
          hlyRouter.push({
            name: 'applicationAcceptanceForm',
            query: {
              mode: 'create',
              formOID: document.formOID,
              formType: document.formType,
            },
          });
          return;
        }
        hlyRouter.push({
          name: 'application-create',
          params: {
            formOID: document.formOID,
            docType: 'application',
            job: job,
          },
          query: {
            formType: document.formType,
            applicantOID: applicant.userOID,
            applicantName: applicant.fullName,
            jobId,
          },
        });
      }
    }
  },
};
